module.exports = __webpack_public_path__ + "static/media/sitting_rue_isolated_flexion_extension.407fbf33.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/quick-play-icons/sitting_rue_isolated_flexion_extension.png
// module id = 726
// module chunks = 0